import React from 'react';

import { getTranslation } from 'helpers/getTranslation';

import { Loading } from 'components/shared/Loading';

import { EmptyState } from 'components/EmptyState';
import { TablePagination } from 'components/TablePagination';

import { Actions } from '../Actions';

import styles from './StudentsUnsubscribeReasons.module.scss';
import { StudentsUnsubscribeReasonsItem } from '../StudentsUnsubscribeReasonsItem';

const StudentsUnsubscribeReasons = ({
  locale,
  loading,
  reasons,
  currentPage,
  totalPages,
  perPage,
  sortParams,
  onPerPageChange,
  onPrevPageClick,
  onNextPageClick,
  onSortChange,
}: {
  locale: any;
  loading: any;
  reasons: any;
  currentPage: any;
  totalPages: any;
  perPage: any;
  sortParams: any;
  onPerPageChange: any;
  onPrevPageClick: any;
  onNextPageClick: any;
  onSortChange: any;
}) => (
  <>
    {loading ? (
      <Loading />
    ) : reasons.length > 0 ? (
      <>
        <Actions onSortChange={onSortChange} sortParams={sortParams} />
        {reasons.map((unsubscribeReason: any) => (
          <div className={styles.item} key={unsubscribeReason.id}>
            <StudentsUnsubscribeReasonsItem
              unsubscribeReason={unsubscribeReason}
              locale={locale}
            />
          </div>
        ))}
        <TablePagination
          currentPage={currentPage}
          perPage={perPage}
          totalPages={totalPages}
          onPerPageChange={onPerPageChange}
          onNextPageClick={onNextPageClick}
          onPrevPageClick={onPrevPageClick}
        />
      </>
    ) : (
      <EmptyState
        className={styles.emptyState}
        icon="mail"
        title={getTranslation(
          'inbox_page.students_unsubscribe_reason.empty_state.title',
        )}
        text=""
      />
    )}
  </>
);
export default React.memo(StudentsUnsubscribeReasons) as any;
